var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("coremh/productDetail"));
    processInclude(require("coreEretailers/product/eretailer"));
    processInclude(require("./components/genericContent"));
    processInclude(require("./components/editorialAssets"));
    processInclude(require("./components/timelineCarousel"));
    processInclude(require("./components/modal"));
    processInclude(require("./components/reviewsCarousel"));
});

require("coremh/thirdParty/css3-animate-it.min");
